import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
};

const DrawerMenu = ({ isOpen, onClose, children, className, title }) => {
  const classes = classNames({
    'drawer-menu': true,
    'drawer-menu-open': isOpen,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="drawer-menu-header">
        <div
          aria-hidden
          tabIndex={-1}
          role="button"
          className="btn-dismiss"
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            onClose?.();
          }}
        >
          &times;
        </div>{' '}
        <p>{title}</p>
      </div>
      <div className="drawer-menu-content">{children}</div>
    </div>
  );
};

DrawerMenu.propTypes = propTypes;

export default DrawerMenu;
